"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", { value: true });
var React = require("react");
var Layouts = require("layouts");
var Snippets = require("snippets");
var Sections = require("sections");
var SearchTemplate = /** @class */ (function (_super) {
    __extends(SearchTemplate, _super);
    function SearchTemplate() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    SearchTemplate.prototype.render = function () {
        var _a = this.props.data, search = _a.search, settings = _a.settings, section = _a.section, customer = _a.customer, shop = _a.shop;
        var bgImage = section.search.settings.background_image;
        var term = search && search.terms ? search.terms.replace(/&quot;/g, "").replace("*", "") : null;
        var searchConfig = shop && shop.metafields && shop.metafields["reactify-search"] && shop.metafields["reactify-search"].config
            ? shop.metafields["reactify-search"].config
            : null;
        return (React.createElement(Layouts.Theme, __assign({}, this.props),
            React.createElement(Snippets.SearchPage, { searchKey: settings.reactify_search_app_key, searchUrl: settings.reactify_search_url, perPage: settings.reactify_search_per_page, searchTerm: term, collection: null, bgImage: bgImage, customer: this.props.data.customer, searchConfig: searchConfig }),
            React.createElement("div", { className: "bg-very-light-pink" },
                React.createElement(Snippets.Container, { tag: "section", width: "xl", className: "px-1-6 md:px-11 pb-0-2" },
                    React.createElement("span", { className: "font-semibold text-xmd text-navy" }, "People also looked at")),
                React.createElement(Sections.FeaturedProducts, __assign({}, this.props, { section: section.prods, customer: customer, simple: true })),
                window.innerWidth < 769 ? null : (React.createElement("div", { className: "pt-4 bg-very-light-pink" },
                    React.createElement(Snippets.Container, { width: "xl", className: "md:px-11 pb-4-8" },
                        React.createElement(Sections.CallToActionHero, __assign({}, this.props, { section: section.ctahero }))))),
                React.createElement(Sections.CTA, __assign({}, this.props, { section: section.cta })))));
    };
    return SearchTemplate;
}(React.Component));
exports.SearchTemplate = SearchTemplate;
